import { reverseCommaSeparatedString } from '@credit-acceptance/shareable-utilities';

import { UTMModel } from '../shared/models/utmModel';
import { ValidationResult } from '../validators/sibling-validation.service';

export const payloadCompiler = (
  sortedResults: ValidationResult[],
  isUserAgreed: boolean,
  userDealerIds?: string[],
  smsConsentGiven = false
): any => {
  const payload: { longFormInfoInput: Record<string, any> } = {
    longFormInfoInput: {
      phoneEmailConsent: isUserAgreed,
      ...(smsConsentGiven && { smsConsent: true }),
    },
  };

  if (userDealerIds?.length) {
    payload.longFormInfoInput.userDealerIds = [...userDealerIds];
  }

  sortedResults.forEach((result: any) => {
    const key =
      payloadMapping[result.componentId as keyof typeof payloadMapping];
    if (key === 'income') {
      payload.longFormInfoInput.income = [
        { ...result.formValue.primary, employmentOrder: 1 },
      ];
      if (result.formValue.secondary) {
        payload.longFormInfoInput.income.push({
          ...result.formValue.secondary,
          employmentOrder: 2,
        });
      }
    } else if (key === 'identification') {
      payload.longFormInfoInput.ssn = result.formValue.ssn;
      payload.longFormInfoInput.creditauthConsent =
        result.formValue.agreement_consent;
    } else {
      payload.longFormInfoInput[key] = result.formValue;
    }
  });
  const { personal } = payload.longFormInfoInput;
  delete personal.emailConfirmation;
  payload.longFormInfoInput.personal = {
    ...payload.longFormInfoInput.personal,
    application: {
      source: getSource(),
    },
    driver: null,
  };
  return payload;
};

export const getSource = (): string => {
  let userSource: UTMModel[] = JSON.parse(
    localStorage.getItem('userSource') || '[]'
  );
  let source = undefined;
  if (userSource.length > 0) {
    //filter it
    userSource = userSource.filter((source) => source.updated); //eleminate the older one
    source = userSource
      .map((item) => {
        const itemurl = item.url ? item.url : '';
        item.url = atob(itemurl);
        const { updated, ...rest } = item; //ignore updated filed.
        return Object.values(rest).join(' ');
      })
      .join(',');
    source = reverseCommaSeparatedString(source);
    source = btoa(source);
  }

  if (source === undefined) {
    source = btoa(window.location.href);
  }
  return source;
};

export const componentMapping = {
  1: '#personal-content',
  2: '#residence-content',
  3: '#income-content',
  4: '#bank-accounts-wrapper',
  5: '#cac-identification-div',
};

export const payloadMapping = {
  1: 'personal',
  2: 'residence',
  3: 'income',
  4: 'account',
  5: 'identification',
};
